(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var P = {
    bed: '<path d="M3 5v14M3 15h18v4M21 15v-3a3 3 0 0 0-3-3h-7v6"/><circle cx="7" cy="11" r="2"/>',
    van: '<path d="M3 6.5h13a3 3 0 0 1 3 3V17H3z"/><path d="M3 11.5h16M8 6.5v5M13 6.5v5"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="15.5" cy="17.5" r="1.8"/>',
    boat: '<path d="M12 3v12M12 4l6.5 9.5H12M11 6 5.5 13.5H11"/><path d="M3 16h18l-2.2 3H5.2z"/>',
    guide: '<path d="M3.5 15.5c0-4.7 3.8-8.5 8.5-8.5s8.5 3.8 8.5 8.5"/><path d="M2.5 15.5h19"/><path d="M8.5 7.8c.8-1.8 2-2.8 3.5-2.8s2.7 1 3.5 2.8"/>',
    meals: '<path d="M7 3v8M4.5 3v5a2.5 2.5 0 0 0 5 0V3M7 11v10"/><path d="M17 21V3c-2.2 1.5-3.2 4.2-3.2 7.5V13H17"/>',
    ticket: '<path d="M3.5 8.5V6h17v2.5a2.5 2.5 0 0 0 0 5V16h-17v-2.5a2.5 2.5 0 0 0 0-5z"/><path d="M14 6v10" stroke-dasharray="2 2"/>',
    plane: '<path d="M2.5 19.5h19"/><path d="M4 13.5l1.2-.5 2.5 2 3.3-1.4L7.2 8.4l1.6-.7 6 4.6 4-1.7a1.6 1.6 0 0 1 1.3 2.9L6.8 18z"/>',
    plus: '<circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/>',
    x: '<circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/>',
    chev: '<path d="M6 9l6 6 6-6"/>',
    cal: '<rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
    pin: '<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
    left: '<path d="M15 6l-6 6 6 6"/>',
    right: '<path d="M9 6l6 6-6 6"/>'
  };
  function icon(name, cls) {
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '1.7');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    s.innerHTML = P[name] || P.plus;
    return s;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function norm(t) { return (t || '').replace(/’/g, "'").trim().toLowerCase(); }
  function findH2(root, starts) {
    var hs = root.querySelectorAll('h2');
    for (var i = 0; i < hs.length; i++) if (norm(hs[i].textContent).indexOf(starts) === 0) return hs[i];
    return null;
  }
  function nextOf(h, cls) {
    var n = h && h.nextElementSibling;
    return n && n.classList.contains(cls) ? n : null;
  }
  function incIcon(t) {
    t = norm(t);
    if (/accommodation|hotel|stay/.test(t)) return 'bed';
    if (/transport|transfer/.test(t)) return 'van';
    if (/boat|cruise|ferr/.test(t)) return 'boat';
    if (/guide|leader/.test(t)) return 'guide';
    if (/meal|food/.test(t)) return 'meals';
    if (/ticket|entr|fee/.test(t)) return 'ticket';
    if (/flight/.test(t)) return 'plane';
    return 'plus';
  }
  var EXC = [
    [/flight/i, 'Flights to and from the start and end of the trip aren’t in the price, unless the trip lists them as included. You can book them separately at any time.'],
    [/visa/i, 'Visa costs aren’t included. Check the entry rules for your passport on travel.gc.ca before you book flights.'],
    [/insurance/i, 'The price doesn’t include travel insurance. We strongly recommend a policy that covers cancellation, medical care and the activities on this trip.'],
    [/tip/i, 'Tips for guides, drivers and crews are optional and at your discretion.'],
    [/drink/i, 'Drinks are paid locally unless a meal says they are included.'],
    [/dinner|lunch|meal/i, 'Meals not listed under What’s included are paid locally, so you can choose where and what to eat.'],
    [/fee|park/i, 'These fees are paid on the day and can change without notice.'],
    [/personal|shopping/i, 'Personal spending such as shopping, laundry and phone costs.']
  ];
  function row(opts) {
    var d = document.createElement(opts.body ? 'details' : 'div');
    d.className = 'tjx-row' + (opts.body ? '' : ' is-static') + (opts.bad ? ' is-bad' : '');
    var sum = el(opts.body ? 'summary' : 'div', 'tjx-sum');
    sum.appendChild(icon(opts.icon, 'tjx-ico'));
    sum.appendChild(el('span', 'tjx-title', opts.title));
    if (opts.body) sum.appendChild(icon('chev', 'tjx-chev'));
    d.appendChild(sum);
    if (opts.body) {
      var b = el('div', 'tjx-body');
      if (typeof opts.body === 'string') b.appendChild(el('p', null, opts.body));
      else b.appendChild(opts.body);
      d.appendChild(b);
    }
    return d;
  }
  function expandAll(h, box) {
    var bar = el('div', 'tjx-head');
    h.parentNode.insertBefore(bar, h);
    bar.appendChild(h);
    var btn = el('button', 'tjx-all', 'Expand all');
    btn.type = 'button';
    btn.addEventListener('click', function () {
      var ds = box.querySelectorAll('details');
      var open = btn.getAttribute('data-open') !== '1';
      ds.forEach(function (d) { d.open = open; });
      btn.setAttribute('data-open', open ? '1' : '0');
      btn.textContent = open ? 'Collapse all' : 'Expand all';
    });
    bar.appendChild(btn);
  }

  function run(root) {
    var hi = findH2(root, "what's included");
    var inc = nextOf(hi, 'tj-inc');
    if (inc) {
      var list = el('div', 'tjx');
      Array.prototype.slice.call(inc.children).forEach(function (c) {
        var h4 = c.querySelector('h4');
        var ul = c.querySelector('ul');
        if (!h4 || !ul) return;
        list.appendChild(row({ icon: incIcon(h4.textContent), title: h4.textContent, body: ul }));
      });
      inc.replaceWith(list);
      expandAll(hi, list);
    }
    var hx = findH2(root, "what's not included");
    var exc = nextOf(hx, 'tj-exc');
    if (exc) {
      var xl = el('div', 'tjx tjx--bad');
      Array.prototype.slice.call(exc.querySelectorAll('li')).forEach(function (li) {
        var t = li.textContent.trim();
        var body = null;
        for (var i = 0; i < EXC.length; i++) if (EXC[i][0].test(t)) { body = EXC[i][1]; break; }
        xl.appendChild(row({ icon: 'x', title: t, body: body, bad: true }));
      });
      exc.replaceWith(xl);
    }
    var hs = findH2(root, "where you'll stay");
    var stay = nextOf(hs, 'tj-stay');
    if (stay) {
      var wrap = el('div', 'tjs');
      var track = el('div', 'tjs-track');
      var note = null;
      Array.prototype.slice.call(stay.children).forEach(function (c) {
        if (c.tagName === 'P') { note = c.textContent.trim(); return; }
        var ps = c.querySelectorAll('p');
        var place = (c.querySelector('h4') || {}).textContent || '';
        var type = ps[0] ? ps[0].textContent.trim() : '';
        var when = '';
        for (var k = 0; k < ps.length; k++) if (ps[k].classList.contains('tj-muted')) when = ps[k].textContent.trim();
        var card = el('div', 'tjs-card');
        var top = el('div', 'tjs-top');
        top.appendChild(icon('pin', 'tjs-pin'));
        top.appendChild(el('span', 'tjs-place', place));
        card.appendChild(top);
        var bodyEl = el('div', 'tjs-body');
        var line = el('p', 'tjs-line');
        line.appendChild(icon('bed'));
        line.appendChild(el('span', null, type));
        bodyEl.appendChild(line);
        var m = type.match(/(\d)\s*-?\s*star/i);
        if (m) {
          var n = parseInt(m[1], 10);
          var st = el('p', 'tjs-stars', '★'.repeat(n));
          st.setAttribute('aria-label', n + ' stars');
          bodyEl.appendChild(st);
        }
        if (when) {
          var wl = el('p', 'tjs-line');
          wl.appendChild(icon('cal'));
          wl.appendChild(el('span', null, when));
          bodyEl.appendChild(wl);
        }
        card.appendChild(bodyEl);
        track.appendChild(card);
      });
      if (note) {
        var np = el('p', 'tjs-note');
        np.appendChild(icon('info'));
        np.appendChild(el('span', null, note));
        wrap.appendChild(np);
      }
      var rail = el('div', 'tjs-rail');
      rail.appendChild(track);
      var prev = el('button', 'tjs-arrow tjs-prev');
      var next = el('button', 'tjs-arrow tjs-next');
      prev.type = next.type = 'button';
      prev.setAttribute('aria-label', 'Previous');
      next.setAttribute('aria-label', 'Next');
      prev.appendChild(icon('left'));
      next.appendChild(icon('right'));
      rail.appendChild(prev);
      rail.appendChild(next);
      wrap.appendChild(rail);
      stay.replaceWith(wrap);
      function upd() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      }
      function step(dir) { track.scrollBy({ left: dir * (track.clientWidth * 0.8), behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
    var hc = findH2(root, 'cancellation');
    if (hc && !document.getElementById('tj-cancel')) hc.id = 'tj-cancel';
    var why = root.querySelector('.tj-why');
    var hg = findH2(root, 'good to know');
    if (why && hg) hg.parentNode.insertBefore(why, hg);
  }

  function init() {
    document.querySelectorAll('[data-tj-trip]').forEach(function (r) {
      if (r.getAttribute('data-ready')) return;
      r.setAttribute('data-ready', '1');
      try { run(r); } catch (e) { if (window.console) console.warn('tj-trip', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('beforeprint', function () { document.querySelectorAll('.tjx details').forEach(function (d) { d.open = true; }); });
})();
